<template>
    <div class="s-box">
        <div 
            class="box"
            :style="{'width':width,'height':height,'background-color':backgroundColor,'border-radius':radius}"
        ></div>
    </div>
</template>

<script>
    export default {
        props:{
            width:{type:String,default:'100%'},
            height:{type:String,default:'17px'},
            backgroundColor:{type:String,default:'#f2f3f5'},
            radius:{type:String,default:'5px'}
        }
    }
</script>

<style lang="less" scoped>
    .s-box{
        >.box{
            border: none;
            animation: van-skeleton-blink 2s ease-in-out infinite;
        }
    }
    @keyframes van-skeleton-blink {
        50% {
            opacity: 0.6;
        }
    }
</style>